import { useQuery } from 'react-query';
import { getDashboardMetrics, type DashboardRange } from '@/services/dashboardService';
import type { ChannelType } from '@/services/channelsService';

export interface UseDashboardMetricsParams {
  range: DashboardRange;
  channel: ChannelType | 'all';
  enabled?: boolean;
}

export function useDashboardMetrics(params: UseDashboardMetricsParams) {
  const { range, channel, enabled = true } = params;

  return useQuery({
    queryKey: ['dashboard-metrics', { range, channel }],
    queryFn: async () => {
      const res = await getDashboardMetrics({ range, channel });
      return res.data;
    },
    enabled,
  });
}
